import { Type } from 'class-transformer';
import { ARAdjustmentAttachmentRawDto } from './ar-adjustment-attachment-raw-dto';

export class ARAdjustmentAttachmentUpdateParameterDto {
    communityId: number;
    managementCompanyId: number;
    arAdjustmentId: number;

    @Type(() => ARAdjustmentAttachmentRawDto)
    attachments: Array<ARAdjustmentAttachmentRawDto>;
}
